import React from 'react';
import { Shield, Sparkles, ArrowRight, Heart, Users, Calendar, BookOpen } from 'lucide-react';

const ColorTestFinal = () => {
  // Pantone 18-4833 TCX (Biscay Bay) variations
  const tealOptions = [
    { name: 'Pantone 18-4833 TCX (Biscay Bay)', hex: '#126872', light: '#1a7882' },
    { name: 'Teal más cálido', hex: '#1a6b6b', light: '#2a7b7b' },
    { name: 'Teal más profundo', hex: '#0d5f69', light: '#1d6f79' },
    { name: 'Teal verdoso', hex: '#1a7268', light: '#2a8278' },
  ];

  // Logo gold color
  const logoGold = '#c9a227';

  return (
    <div className="min-h-screen bg-white pt-24 pb-20">
      <div className="max-w-6xl mx-auto px-6">
        <h1 className="text-4xl font-heading text-center mb-4">Prueba Final de Colores</h1>
        <p className="text-center text-gray-600 mb-12">
          <strong>Límites:</strong> Dorado del logo ({logoGold})<br/>
          <strong>Facilitadoras:</strong> Pantone 18-4833 TCX (Biscay Bay) y variaciones
        </p>

        {/* LÍMITES - Con dorado del logo */}
        <div className="mb-16">
          <h2 className="text-2xl font-heading mb-6 flex items-center gap-3">
            <div className="w-8 h-8 rounded-full" style={{ backgroundColor: logoGold }}></div>
            Curso LÍMITES - Dorado del Logo
          </h2>
          
          <div 
            className="rounded-3xl overflow-hidden shadow-xl"
            style={{ background: `linear-gradient(135deg, #8a7428 0%, #a68a30 100%)` }}
          >
            <div className="p-8 lg:p-10">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                <div>
                  <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-4">
                    <Shield className="w-4 h-4" style={{ color: '#f0e6c0' }} />
                    <span className="text-sm text-white/90">Formación Especial · En vivo</span>
                  </div>
                  <h3 className="text-3xl lg:text-4xl font-heading text-white mb-2 tracking-tight">LÍMITES</h3>
                  <p className="text-lg text-white/70 font-heading mb-4">La protección original de la consciencia</p>
                  <p className="text-white/60 mb-6">Un master-curso encarnado para recuperar tu eje sin culpa, sin dureza y sin perder el corazón.</p>
                  <div className="flex gap-3">
                    <button className="px-6 py-3 rounded-full text-sm font-medium bg-white text-[#8a7428]">
                      Solicitar acceso
                    </button>
                    <button 
                      className="px-6 py-3 rounded-full text-sm font-medium text-white"
                      style={{ backgroundColor: logoGold }}
                    >
                      Ver más
                    </button>
                  </div>
                </div>
                <div className="flex items-center justify-center">
                  <div className="text-center p-8 bg-white/10 rounded-2xl">
                    <Shield className="w-16 h-16 mx-auto mb-4 text-white/30" strokeWidth={1} />
                    <p className="text-white/70 italic font-heading">"El límite no separa. Protege."</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FACILITADORAS - Variaciones de Teal */}
        <h2 className="text-2xl font-heading mb-6">Facilitadoras - Opciones Teal (Pantone 18-4833)</h2>
        
        <div className="space-y-10">
          {tealOptions.map((option, idx) => (
            <div key={idx}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 rounded-full shadow" style={{ backgroundColor: option.hex }}></div>
                <div>
                  <p className="font-heading">{option.name}</p>
                  <p className="text-xs text-gray-400 font-mono">{option.hex}</p>
                </div>
              </div>
              
              <div 
                className="rounded-3xl overflow-hidden shadow-xl"
                style={{ background: `linear-gradient(135deg, ${option.hex} 0%, ${option.light} 100%)` }}
              >
                <div className="p-8 lg:p-10">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                    <div>
                      <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-4">
                        <Sparkles className="w-4 h-4" style={{ color: logoGold }} />
                        <span className="text-sm text-white/90">Formación Especial · En vivo</span>
                      </div>
                      <h3 className="text-3xl lg:text-4xl font-heading text-white mb-4">
                        Facilitadores en Sostén Energético
                      </h3>
                      <p className="text-white/70 mb-6">
                        Sostener es un arte vibracional. Una formación para quienes acompañan procesos de transformación.
                      </p>
                      <div className="flex flex-wrap gap-4 mb-6">
                        <div className="flex items-center gap-2 text-white/60">
                          <BookOpen className="w-4 h-4" />
                          <span className="text-sm">12 clases online</span>
                        </div>
                        <div className="flex items-center gap-2 text-white/60">
                          <Users className="w-4 h-4" />
                          <span className="text-sm">Plazas limitadas</span>
                        </div>
                      </div>
                      <div className="flex gap-3">
                        <button 
                          className="px-6 py-3 rounded-full text-sm font-medium text-white"
                          style={{ backgroundColor: logoGold }}
                        >
                          Ver formación
                          <ArrowRight className="w-4 h-4 inline ml-2" />
                        </button>
                        <span className="flex items-baseline gap-2">
                          <span className="text-2xl font-heading" style={{ color: logoGold }}>desde 1.020€</span>
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center justify-center">
                      <div className="text-center p-8 bg-white/10 rounded-2xl">
                        <Heart className="w-16 h-16 mx-auto mb-4" style={{ color: `${logoGold}40` }} strokeWidth={1} />
                        <p className="text-white/70 italic font-heading">"Sostener es un arte vibracional"</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Summary */}
        <div className="mt-16 p-8 bg-gray-100 rounded-3xl">
          <h2 className="text-2xl font-heading mb-6 text-center">Resumen de Propuesta</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-2xl text-center">
              <div className="w-20 h-12 rounded-lg mx-auto mb-4 shadow" style={{ background: 'linear-gradient(135deg, #8a7428, #a68a30)' }}></div>
              <h3 className="font-heading mb-2">LÍMITES</h3>
              <p className="text-sm text-gray-600">Dorado oscuro basado en el logo</p>
              <p className="text-xs font-mono text-gray-400 mt-2">#8a7428 → #a68a30</p>
            </div>
            <div className="bg-white p-6 rounded-2xl text-center">
              <div className="w-20 h-12 rounded-lg mx-auto mb-4 shadow" style={{ background: 'linear-gradient(135deg, #126872, #1a7882)' }}></div>
              <h3 className="font-heading mb-2">FACILITADORAS</h3>
              <p className="text-sm text-gray-600">Teal Biscay Bay (Pantone 18-4833)</p>
              <p className="text-xs font-mono text-gray-400 mt-2">#126872 → #1a7882</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorTestFinal;
